<app-resp-popup-title>
  <mat-icon>file_upload</mat-icon
    ><span i18n="@@Infoportal_Add_New_Document">Upload a new Document</span>
  </app-resp-popup-title>
  <app-resp-popup-content id="document-create-content">
    <div id="document-create-wrapper">
      @if (form && !loading) {
        <form [formGroup]="form">
          <fieldset>
            @if (displayFolderSelection) {
              <frm-infoportal-folder-select
                i18n-label="@@Infoportal_AddDocument_Folder"
                label="Folder"
                formControlName="vorgangID"
                [facilityID]="data?.facilityID"
              ></frm-infoportal-folder-select>
            }
            <frm-text
              i18n-label="@@Infoportal_AddDocument_Description"
              label="Description"
              formControlName="bezeichnung"
              >
            </frm-text>
            <infoportal-tags-select
              (selected)="onTagSelection($event)"
            ></infoportal-tags-select>
            @if (displayInternToggle) {
              <mat-slide-toggle
                [formControlDisabled]="formCanBeEdited === false"
                formControlName="enableExternalAccess"
                i18n="@@Infoportal_EnableExternalAccess"
                [labelPosition]="'before'"
                [color]="sliderColor"
                ngDefaultControl
                >Enable external access</mat-slide-toggle
                >
              }
              <frm-file-select
                [disabled]="loading"
                [files]="userFiles"
                (fileSelectionChanged)="onFileSectionChanged($event)"
              ></frm-file-select>
            </fieldset>
          </form>
        } @else {
          <app-shimmer [isLoading]="true" type="custom">
            <ng-template shimmerPreviewTemplate>
            </ng-template>
          </app-shimmer>
        }
      </div>
    </app-resp-popup-content>
    <app-resp-popup-actions>
      <!-- <div *ngIf="!loading; else shimmerActions"> -->
      @if (!loading) {
        <div>
          <ctrl-btn-accept
            [disabled]="loading || !form.valid"
            (click)="onAccept($event)"
          ></ctrl-btn-accept>
          <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
        </div>
      } @else {
        <div class="container">
          <mat-progress-bar
            mode="indeterminate"
            style="height:10px; border-radius: 15px;"
          ></mat-progress-bar>
        </div>
      }
    </app-resp-popup-actions>




    <!-- Originals -->

    <!-- <ng-template #shimmer>
    <app-shimmer [isLoading]="true" type="custom">
      <ng-template shimmerPreviewTemplate>
        <app-shimmer-input *ngIf="displayFolderSelection"></app-shimmer-input>
        <app-shimmer-input ></app-shimmer-input>
        <app-shimmer-input ></app-shimmer-input>
        <app-shimmer-label ></app-shimmer-label>
        <app-shimmer-input height="228px"></app-shimmer-input>
      </ng-template>
    </app-shimmer>
  </ng-template> -->

  <!-- <ng-template #shimmerActions>
  <app-shimmer [isLoading]="true" type="custom">
    <ng-template shimmerPreviewTemplate>
      <app-shimmer-input
        width="200px"
        style="display: inline-block"
      ></app-shimmer-input>
      <app-shimmer-input
        width="200px"
        style="display: inline-block"
      ></app-shimmer-input>
    </ng-template>
  </app-shimmer>
</ng-template> -->